module.exports = __webpack_public_path__ + "static/the-ascent-of-money-0fe76d43806b90a2eac9958c313a4e5c.jpg";